/**
 * Walkthrough #39 / #84 (2026-09-29): a candidate who PICKED an answer and
 * then let the clock run out lost it. A pick is only saved on "Submit & next"
 * or by the time-up handler — and that one fires at 0 remaining, so its POST
 * reaches the server after `expires_at` by construction and is refused 410
 * (per-question it scored 0%). The server deliberately has no grace window
 * (see `_enforce_deadline`: nothing may be added after the deadline), so the
 * save has to land BEFORE it: once, this long before the end, whenever an
 * answer is on screen. A change in the very last seconds still misses — the
 * earlier pick is what counts.
 */
export const PRE_DEADLINE_SAVE_MS = 3_000;

export function shouldSaveBeforeDeadline(
  remainingMs: number | null,
  alreadySaved: boolean,
  answered: boolean,
): boolean {
  return (
    !alreadySaved &&
    answered &&
    remainingMs !== null &&
    remainingMs > 0 &&
    remainingMs <= PRE_DEADLINE_SAVE_MS
  );
}
